import 'zone.js';
import '@angular/localize/init';
import { setScriptKey } from '@progress/kendo-licensing';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor } from './app/core/http/auth.interceptor';
import { httpErrorInterceptor } from './app/core/http/http-error.interceptor';
import { ConfigService } from './app/core/services/config.service';

// Configure Kendo UI License from telerik-license.txt
// The license key is auto-generated from telerik-license.txt by scripts/generate-license.js
import { KENDO_LICENSE_KEY } from './app/core/config/kendo-license';

try {
  if (KENDO_LICENSE_KEY && KENDO_LICENSE_KEY.trim().length > 0) {
    setScriptKey(KENDO_LICENSE_KEY.trim());
    console.log('✅ Kendo UI license key activated successfully');
  } else {
    console.warn('⚠️ Kendo UI license key is empty or missing. Running in trial mode.');
  }
} catch (error) {
  console.error('❌ Failed to set Kendo UI license key:', error);
}

function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(NotificationModule),
    // Using SVG icons by default (no need to configure ICON_SETTINGS for SVG)
    provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true,
    },
  ],
}).catch((err) => console.error(err));
